import { useMemo } from 'react';
import Empty from 'constants/empty';
import DeliveryFrequencyUtils from 'utils/DeliveryFrequency';
import LanguageLocale from 'utils/LanguageLocale';
import BasketUtils from 'utils/Basket';
import DateUtils from 'utils/Date';
import AutoReplenishmentCancelledItemEN from 'components/RichProfile/MyAccount/AutoReplenishment/locales/AutoReplenishment_en_US';
import AutoReplenishmentCancelledItemFR from 'components/RichProfile/MyAccount/AutoReplenishment/locales/AutoReplenishment_fr_CA';

const { getLocalisedDataFromResource } = LanguageLocale;
const { formatCurrency } = DeliveryFrequencyUtils;

const getText = getLocalisedDataFromResource(AutoReplenishmentCancelledItemEN, AutoReplenishmentCancelledItemFR);

/**
 * Derives display data for a cancelled auto-replenishment subscription item.
 *
 * @param {Object} params
 * @param {Object} params.subscription - Cancelled subscription data
 * @returns {{ localization: Object, product: Object, hasItemVariation: boolean, subscriptionEndDate: string|null }}
 */
const useAutoReplenishmentCancelledItem = ({ subscription }) => {
    const { items = Empty.Array } = subscription || Empty.Object;
    const product = items?.[0] || Empty.Object;

    const localization = useMemo(() => {
        return {
            viewProductDetails: getText('viewProductDetails'),
            cancelledOn: getText('cancelledOn', ['{0}']),
            discountRate: getText('discountRate', ['{0}'])
        };
    }, []);

    const productData = useMemo(
        () => ({
            ...product,
            productPrice: formatCurrency(parseFloat(BasketUtils.removeCurrency(product.price)), product.qty),
            discountRate: parseFloat(product.discountAmount)
        }),
        [product]
    );

    const subscriptionEndDate = subscription?.subscriptionEndDate ? DateUtils.formatStringDateToMMDDYY(subscription.subscriptionEndDate) : null;

    const hasItemVariation = !!(product.variationType && product.variationValue && product.skuId);

    return {
        localization,
        product: productData,
        hasItemVariation,
        subscriptionEndDate
    };
};

export default useAutoReplenishmentCancelledItem;
